import React from 'react';
import ReportingGivingByCampaignPage from '../components/ReportingGivingByCampaignPage';

const ReportingGivingByCampaignApp = (props) => (
  <ReportingGivingByCampaignPage {...props} />
);

export default ReportingGivingByCampaignApp;
